module.exports = __webpack_public_path__ + "img/picto-car-elec.a17c82f0.png";